<template>
    <pop-over class="popover-bg">
      <template #content="{ toggle }">
        <div class="popover-content">
            <header class="popover-header">
                <h3>{{ $t('message.support.message.doubtsPopup') }}</h3>
                <i class="mdi mdi-close" @click="toggle" />
            </header>

            <div class="popover-text">
                <span>
                    {{ $t('message.support.message.sendSupportEmail') }}
                </span>
                <b>
                    {{ email }}
                    <v-icon size="14" @click="copy">mdi-content-copy</v-icon>
                </b>
                <span>{{ $t('message.support.message.supportEmailHelp') }}</span>
            </div>
        </div>
      </template>

      <template #button>
        <support-icon class="support-icon"></support-icon>
      </template>
    </pop-over>
</template>

<script>
import EventBus from '../packages/event-bus';
import PopOver from './generic/PopOver.vue';
import SupportIcon from './icons/SupportIcon.vue';

export default {
    components: {
        PopOver,
        SupportIcon
    },

    props: {
        email: {
            type: String,
            required: true
        }
    },

    methods: {
        async copy() {
            try {
                await navigator.clipboard.writeText(this.email);

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: this.$t('message.successMessages.message.valueCopied'),
                });
            } catch (e) {
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t('message.support.message.copyError'),
                });
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import "~@scss/variables.scss";

.popover-bg {
    position: absolute;
    right: 16px;
    bottom: 16px;
}

.popover-content {
    max-width: 375px;
    height: 100%;
    background-color: white;
    border-radius: 16px 16px 12px 12px;
    box-shadow: 0px 3px 6px #00000024;
}
.popover-header {
    background: var(--support-primary, #{$vivo-purple});
    color: var(--support-foreground, white);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    position: relative;
    border-radius: 12px 12px 0 0;

    & h3 {
        font-weight: bold;
    }

    & i {
        position: absolute;
        right: 12px;
        cursor: pointer;
    }
}

.support-icon {
    margin: 12px;
}

.popover-text {
    display: flex;
    flex-direction: column;
    padding: 24px;
    font-size: 14px;
    text-align: center;
    margin: 0 !important;
}

</style>
